import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-137a7867"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "content",
  role: "tabpanel"
}
const _hoisted_2 = { class: "filter-content" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "search-input-wrapper" }
const _hoisted_6 = ["alt"]
const _hoisted_7 = ["aria-label", "placeholder", "onKeypress"]
const _hoisted_8 = ["alt"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "list-title list-title-yellow" }
const _hoisted_12 = {
  key: 0,
  class: "list playlist-carousel list-unstyled"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "list-text" }
const _hoisted_16 = {
  key: 1,
  scrollbar: "true",
  "space-between": "5.2",
  "slides-per-view": "auto",
  class: "list playlist-carousel list-unstyled"
}
const _hoisted_17 = ["href"]
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = { class: "list-text" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "list-wrap"
}
const _hoisted_23 = { class: "list list-unstyled" }
const _hoisted_24 = ["href"]
const _hoisted_25 = ["src", "alt"]
const _hoisted_26 = ["src", "alt"]
const _hoisted_27 = { class: "list-text" }

import { PlaylistDto } from '@/models/FilterPageTypes';
import { useFilterPageStore } from '@/stores/filterPageStore'
import { computed, ref } from 'vue'
import { register } from 'swiper/element/bundle'
import { WINDOW_WIDTH } from '@/models/WidthTypeEnum'


export default /*#__PURE__*/_defineComponent({
  __name: 'PlaylistsCollections',
  setup(__props) {

register()

const filterPageStore = useFilterPageStore();
let filteredPlaylits = ref<Array<PlaylistDto>>([]);
let searchValue = ref<string>();
let searchMode = ref<boolean>(false);
let numberOfItemsValue = ref<string>();
let notFoundValue = ref<string>();

let windowWidth = computed(() => window.innerWidth)

const playlistsGroups = computed(() => filterPageStore.playlistsGroups)
const playlistsOverviewDescr = computed(() => filterPageStore.playlistsOverviewDescr)
const playlists = computed(() => filterPageStore.returnPlaylists())

const numberOfItems = computed(() => filterPageStore.getLocalization("FilterPage.PlaylistCollection.NumberOfItems"))
const searchPlaceholder = computed(() => filterPageStore.getLocalization("FilterPage.PlaylistCollection.SearchPlaceholder"))
const playlistsAbsence = computed(() => filterPageStore.getLocalization("FilterPage.PlaylistCollection.PlaylistsAbsence"))
const notFound = computed(() => filterPageStore.getLocalization("FilterPage.PlaylistCollection.NotFound"))
const altClose = computed(() => filterPageStore.getLocalization("Accessability.Images.Close"))
const altSearch = computed(() => filterPageStore.getLocalization("Accessability.Images.Search"))
const ariaLabelSearch = computed(() => filterPageStore.getLocalization("Accessability.Search.Description"))
const inputClass = computed(() => {
    return [
        { 'filled-input': searchValue.value }
    ]
})

async function onPlaylistsSearch() {
    filteredPlaylits.value = []
    if (!searchValue.value) {
        searchMode.value = false;
        return
    }
    searchMode.value = true;
    filteredPlaylits.value = playlists.value.filter((element: any) => element.Title.includes(searchValue.value ?? ""))
    numberOfItemsValue.value = numberOfItems.value.replace('{{number}}', filteredPlaylits.value.length.toString()).replace('{{search}}', searchValue.value)
    notFoundValue.value = notFound.value.replace('{{keyword}}', searchValue.value);
}

function Clear() {
    searchMode.value = false;
    searchValue.value = "";
    return;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", { innerHTML: _unref(playlistsOverviewDescr) }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_unref(searchValue))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: Clear,
              class: "playlist-search-close"
            }, [
              _createElementVNode("img", {
                src: "/images/ico-close.svg",
                alt: _unref(altClose)
              }, null, 8, _hoisted_6)
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["search-input search-input-white search-input-playlist", _unref(inputClass)]),
          "aria-label": _unref(ariaLabelSearch),
          type: "text",
          placeholder: _unref(searchPlaceholder),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchValue) ? (searchValue).value = $event : searchValue = $event)),
          onKeypress: _withKeys(onPlaylistsSearch, ["enter"])
        }, null, 42, _hoisted_7), [
          [_vModelText, _unref(searchValue)]
        ]),
        _createElementVNode("button", {
          onClick: onPlaylistsSearch,
          class: "playlist-search"
        }, [
          _createElementVNode("img", {
            src: "/images/ico-search-dark.svg",
            alt: _unref(altSearch)
          }, null, 8, _hoisted_8)
        ])
      ])
    ]),
    (!_unref(searchMode))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_unref(playlists).length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("p", null, _toDisplayString(_unref(playlistsAbsence)), 1)
              ]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(playlistsGroups), (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "list-wrap",
                  key: item.KeyId
                }, [
                  _createElementVNode("h2", _hoisted_11, _toDisplayString(item.Name), 1),
                  (_unref(windowWidth) > _unref(WINDOW_WIDTH).lg)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Playlists, (playlist) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "list-item",
                            key: playlist.KeyId
                          }, [
                            _createElementVNode("a", {
                              href: playlist.Url,
                              class: "list-link",
                              tabindex: "0"
                            }, [
                              _createElementVNode("img", {
                                class: "img-fluid d-none d-lg-block",
                                src: playlist.DesktopPreview.Url,
                                alt: playlist.DesktopPreview.Alt
                              }, null, 8, _hoisted_14),
                              _createElementVNode("div", _hoisted_15, _toDisplayString(playlist.Title), 1)
                            ], 8, _hoisted_13)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("swiper-container", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Playlists, (playlist) => {
                          return (_openBlock(), _createElementBlock("swiper-slide", {
                            class: "list-item",
                            key: playlist.KeyId
                          }, [
                            _createElementVNode("a", {
                              href: playlist.Url,
                              class: "list-link",
                              tabindex: "0"
                            }, [
                              _createElementVNode("img", {
                                class: "img-fluid d-lg-none",
                                src: playlist.MobilePreview.Url,
                                alt: playlist.MobilePreview.Alt
                              }, null, 8, _hoisted_18),
                              _createElementVNode("div", _hoisted_19, _toDisplayString(playlist.Title), 1)
                            ], 8, _hoisted_17)
                          ]))
                        }), 128))
                      ]))
                ]))
              }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_20, [
          (_unref(filteredPlaylits).length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(notFoundValue)), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("p", null, _toDisplayString(_unref(numberOfItemsValue)), 1),
                _createElementVNode("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredPlaylits), (playlist) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "list-item",
                      key: playlist.KeyId
                    }, [
                      _createElementVNode("a", {
                        href: playlist.Url,
                        class: "list-link",
                        tabindex: "0"
                      }, [
                        _createElementVNode("img", {
                          class: "img-fluid d-lg-none",
                          src: playlist.DesktopPreview.Url,
                          alt: playlist.DesktopPreview.Alt
                        }, null, 8, _hoisted_25),
                        _createElementVNode("img", {
                          class: "img-fluid d-none d-lg-block",
                          src: playlist.MobilePreview.Url,
                          alt: playlist.MobilePreview.Alt
                        }, null, 8, _hoisted_26),
                        _createElementVNode("div", _hoisted_27, _toDisplayString(playlist.Title), 1)
                      ], 8, _hoisted_24)
                    ]))
                  }), 128))
                ])
              ]))
        ]))
  ]))
}
}

})